import type { TFunction } from "i18next";
import { TOutlineChangeStatus, TActionButton } from "../model/types";

type TNotificationConfig = {
  content: string;
  changes: string[];
  question: string;
  actionButtons: TActionButton[];
};

type TPresentationT = TFunction<"projectHome">;

const getNotificationActionButtons = (t: TPresentationT): TActionButton[] => [
  { label: t("presentation.notifications.refresh"), message: t("presentation.notifications.refreshMessage"), action: "submit" },
  {
    label: t("presentation.notifications.keepCurrent"),
    message: t("presentation.notifications.keepCurrentMessage"),
    appearance: "text" as const,
    action: "dismiss",
    responseMessage: t("presentation.notifications.keptResponse")
  }
];

export const getNotificationConfig = (
  t: TPresentationT
): Partial<Record<TOutlineChangeStatus, TNotificationConfig>> => ({
  source_changed: {
    content: t("presentation.notifications.sourceChangedContent"),
    changes: [t("presentation.notifications.sourceModified")],
    question: t("presentation.notifications.refreshQuestion"),
    actionButtons: getNotificationActionButtons(t)
  },
  instructions_changed: {
    content: t("presentation.notifications.instructionsChangedContent"),
    changes: [t("presentation.notifications.instructionsUpdated")],
    question: t("presentation.notifications.refreshQuestion"),
    actionButtons: getNotificationActionButtons(t)
  },
  both_changed: {
    content: t("presentation.notifications.bothChangedContent"),
    changes: [t("presentation.notifications.sourceModified"), t("presentation.notifications.instructionsUpdated")],
    question: t("presentation.notifications.refreshQuestion"),
    actionButtons: getNotificationActionButtons(t)
  }
});

export const getTooltipConfig = (
  t: TPresentationT
): Record<TOutlineChangeStatus, { title: string; description: string; barColor: string }> => ({
  no_outline: {
    title: t("presentation.status.noOutlineTitle"),
    description: t("presentation.status.noOutlineDescription"),
    barColor: "bg-innoveraZinc-500"
  },
  up_to_date: {
    title: t("presentation.status.upToDateTitle"),
    description: t("presentation.status.upToDateDescription"),
    barColor: "bg-innoveraZinc-500"
  },
  source_changed: {
    title: t("presentation.status.sourceChangedTitle"),
    description: t("presentation.status.sourceChangedDescription"),
    barColor: "bg-[#E6A539]"
  },
  instructions_changed: {
    title: t("presentation.status.instructionsChangedTitle"),
    description: t("presentation.status.instructionsChangedDescription"),
    barColor: "bg-[#D93D3D]"
  },
  both_changed: {
    title: t("presentation.status.bothChangedTitle"),
    description: t("presentation.status.bothChangedDescription"),
    barColor: "bg-[#D93D3D]"
  }
});
